import React from 'react';
import PropTypes from 'prop-types';

const Logo = (props) => {
  const { width } = props;
  if (!width) {
    props = { ...props, width: '50' };
  }
  return <img alt="Logo" src="/static/logo.png" {...props} />;
};

Logo.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Logo;
